import React, { useMemo, useState } from "react";
import { formatCNPJ } from "../../utils/utilityFunctions";
import "../ProfileSelectCard/style.css";
import "./style.css";

const normalizeSearchValue = (value) =>
  (value || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

export default function MultiUnitSelector({
  profiles,
  onConfirm,
  initialSelectedIds = [],
  viewModeToggle,
}) {
  const [selectedIds, setSelectedIds] = useState(initialSelectedIds);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProfiles = useMemo(() => {
    const normalizedTerm = normalizeSearchValue(searchTerm);

    return (profiles || []).filter((profile) => {
      if (!normalizedTerm) return true;

      return (
        (profile.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        normalizeSearchValue(profile.cnpj).includes(normalizedTerm)
      );
    });
  }, [profiles, searchTerm]);

  const toggleProfile = (profileId) => {
    setSelectedIds((currentIds) =>
      currentIds.includes(profileId)
        ? currentIds.filter((id) => id !== profileId)
        : [...currentIds, profileId]
    );
  };

  const selectAll = () =>
    setSelectedIds((profiles || []).map((profile) => profile.id));

  const totalCount = profiles?.length ?? 0;

  return (
    <div className="profile-select-container">
      <h1 className="profile-select-title">
        Escolha a unidade consumidora para visualizar suas informações
      </h1>

      <div className="profile-search-row">
        {viewModeToggle}

        <div className="profile-search-group">
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="profile-search-input"
            placeholder=" "
            aria-label="Buscar unidade por nome ou CNPJ"
          />
          <span className="profile-search-bar" />
          <label className="profile-search-label">
            Buscar unidade por nome ou CNPJ
          </label>
        </div>

        <span className="profile-search-count" aria-live="polite">
          {selectedIds.length} de {totalCount} unidades selecionadas
        </span>
      </div>

      <div className="multi-unit-selector__actions">
        <button type="button" className="btn btn-light" onClick={selectAll}>
          Selecionar todas
        </button>
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setSelectedIds([])}
        >
          Limpar seleção
        </button>
      </div>

      <div className="profile-cards-grid">
        {filteredProfiles.map((profile) => {
          const isSelected = selectedIds.includes(profile.id);

          return (
            <div
              key={profile.id}
              className={`profile-select-card ${isSelected ? "selected" : ""}`}
              onClick={() => toggleProfile(profile.id)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  toggleProfile(profile.id);
                }
              }}
            >
              <div className="profile-card-header">
                <h3 className="profile-company-name">
                  {profile.company_name?.toUpperCase()}
                </h3>
                {isSelected && (
                  <span className="selected-check" aria-label="Selecionado">
                    ✓
                  </span>
                )}
              </div>
              <div className="profile-card-body">
                <div className="profile-info-item">{profile.name}</div>
                <div className="profile-info-item">
                  {formatCNPJ(profile.cnpj)}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="multi-unit-selector__footer">
        <span>
          {selectedIds.length < 2 &&
            "Selecione ao menos 2 unidades para continuar."}
        </span>
        <button
          type="button"
          className="btn btn-primary"
          disabled={selectedIds.length < 2}
          onClick={() => onConfirm(selectedIds)}
        >
          Visualizar dados
        </button>
      </div>
    </div>
  );
}
